/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CompetitionBrowseResult
 */
export interface CompetitionBrowseResult {
    /**
     * 
     * @type {number}
     * @memberof CompetitionBrowseResult
     */
    rank: number;
    /**
     * 
     * @type {string}
     * @memberof CompetitionBrowseResult
     */
    displayName: string;
    /**
     * The final score.
     * @type {number}
     * @memberof CompetitionBrowseResult
     */
    value: number;
    /**
     * What this place was paid, as printed — "$50", "$5 Competition Token". Absent when the place paid nothing.
     * @type {string}
     * @memberof CompetitionBrowseResult
     */
    prize?: string;
}

/**
 * Check if a given object implements the CompetitionBrowseResult interface.
 */
export function instanceOfCompetitionBrowseResult(value: object): value is CompetitionBrowseResult {
    if (!('rank' in value) || value['rank'] === undefined) return false;
    if (!('displayName' in value) || value['displayName'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function CompetitionBrowseResultFromJSON(json: any): CompetitionBrowseResult {
    return CompetitionBrowseResultFromJSONTyped(json, false);
}

export function CompetitionBrowseResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompetitionBrowseResult {
    if (json == null) {
        return json;
    }
    return {
        
        'rank': json['rank'],
        'displayName': json['displayName'],
        'value': json['value'],
        'prize': json['prize'] == null ? undefined : json['prize'],
    };
}

export function CompetitionBrowseResultToJSON(json: any): CompetitionBrowseResult {
    return CompetitionBrowseResultToJSONTyped(json, false);
}

export function CompetitionBrowseResultToJSONTyped(value?: CompetitionBrowseResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'rank': value['rank'],
        'displayName': value['displayName'],
        'value': value['value'],
        'prize': value['prize'],
    };
}

